export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_1.5-2b62d83d0247ec39cf561d7cb8d3b017.svg";